import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService } from 'src/app/services/http.service';

// Models
import { Product } from 'src/app/models/product';

@Injectable({
  providedIn: 'root'
})
export class AddProductService {

  static productSelected: Product = new Product();

  // Objetos Observable y Emiters
  private productSelected$ = new Subject<Product>();

  constructor(
    private _httpService: HttpService
  ) { }

  setProduct(product: Product): void {
    AddProductService.productSelected = product;
    this.productSelected$.next(product);
  }

  getSubjetProductSelected(): Subject<Product> {
    return this.productSelected$;
  }

  // Servicios HTTP
  addProductToShoppingCar(data: any) {
    return this._httpService.httpPost(`compras/cliente/${data.client_id}`, data);
  }

  getAditionals(productId: string) {
    let headers = {
      'dataAdicionales': 'true',
      'dataImagenes': 'true'
    }
    return this._httpService.httpGet(`productos/producto/${productId}`, headers);
  }



}
